// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._zulp1b66{gap:var(--ds-space-050,4px)}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/smart-card/dist/esm/view/FlexibleCard/components/blocks/title-block/resolved/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,2BAA2B","sourcesContent":["._zulp1b66{gap:var(--ds-space-050,4px)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
